import getTruthyKeys from "../getTruthyKeys"
import { db } from "../../config/firebaseconfig"
import parseSnapshot from "../parseSnapshot"
import requestGroupUAUpdate from "./requestGroupUAUpdate"

/**
 * Requests a groupUAUpdate from the cloud function for all GUA's associated with a student
 * @param {object} student the student object
 * @param {string} assessmentId set id of the assessment
 * @param {string} year year (e.g. 2018 represents the 2018-19 school year)
 */
export default function updateAllGroupUAsWithStudent (student, assessmentId, year) {
  if (!student) return Promise.reject()
  const classes = getTruthyKeys(student.classes)
  return db.collection('educators').where('school', '==', student.school).get()
    .then(querySnapshot => {
      let teachers = {}
      const educators = Object.values(parseSnapshot(querySnapshot))
      educators.forEach(educator => {
        if (!educator.classes) return
        classes.forEach(cl => {
          if (educator.classes[cl]) {
            teachers[educator.id] = true
          }
        })
      })
      let teachersArray = Object.keys(teachers)
      const groupUAIds = [
        student.schoolDistrict,
        student.school,
        ...classes,
        ...teachersArray,
      ]
      const updateRequests = groupUAIds.map(groupUAId => {
        return requestGroupUAUpdate(groupUAId, assessmentId, year)
      })
      return Promise.all(updateRequests)
    }) 
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/updateAllGroupUAsWithStudent.js